import * as React from "react"
import { connect } from "react-redux"
import { VisioMap } from "react-visioglobe"
import config from "../../../config"
import actions from "../../../store/actions"
import logger from "../../../utils/logger"
import type { TypeI18n } from "../../../store/i18n/I18NReducer"
import { TypeStatus } from "../../../store/plans/PlansReducer"

type Props = {
  +i18n: TypeI18n,
  +fetchPoisStatuses: () => Promise<any>,
  +poisStatuses: TypeStatus[]
}

const REFRESH_TIMER: string = 120000

class Plans extends React.Component<Props, void> {
  componentDidMount() {
    this.props.fetchPoisStatuses().catch(err => logger.error(err))
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.props.fetchPoisStatuses().catch(err => logger.error(err))
      }, REFRESH_TIMER)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.vg && nextProps.vg.initialised && !this.initialised) {
      this.initialised = true
      this.updateVG(nextProps)
      this.props.fetchPoisStatuses().catch(err => logger.error(err))
      if (document.location.href.indexOf("?floor=") > 0) {
        const floor = document.location.href.substring(
          document.location.href.indexOf("=") + 1
        )
        this.props.gotoFloor(floor, {
          heading: 123,
          radiusFactor: 0.87
        })
      }
    } else if (this.initialised) {
      if (this.props.poisStatuses !== nextProps.poisStatuses) {
        this.updateVG(nextProps)
      }
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  updateVG = props => {
    const colorMap = props.poisStatuses.reduce((acc, cur) => {
      acc[cur.spaceId] = cur.color
      return acc
    }, {})

    props.vg.data.places.forEach(p => {
      const color = colorMap[p.id]
      if (color) {
        p.vg.setColor(color)
      }
    })
  }

  render() {
    return (
      <div
        style={{ position: "absolute", top: 0, left: 0, bottom: 0, right: 0 }}
      >
        <VisioMap
          key="map"
          map={
            "https://mapserver.visioglobe.com/" +
            config.visioglobe.mapHash +
            "/map.json"
          }
          rotationEnabled={true}
          pitchEnabled={true}
          placeInfoComponent={null}
          initialGoTo={() => {}}
          rotation={123}
        />
      </div>
    )
  }
}

export { Plans }

const PlansConnected = connect(
  s => ({
    i18n: s.i18n,
    vg: s.vg,
    poisStatuses: s.plans.status
  }),
  d => ({
    fetchPoisStatuses: () => d(actions.plans.fetchStatuses()),
    gotoFloor: (id, cameraConfig) => d(actions.vg.gotoFloor(id, cameraConfig)),
    gotoPlace: id => d(actions.vg.gotoPlace(id)),
    clearPlaceSelection: () => d(actions.vg.clearPlaceSelection()),
    routeStart: (fromId, toId, lng) =>
      d(actions.vg.routeStart(fromId, toId, lng)),
    routeGotoStep: idx => d(actions.vg.routeGotoStep(idx)),
    routeEnd: () => d(actions.vg.routeStop()),
    gotoGlobal: () => d(actions.vg.gotoGlobal())
  })
)(Plans)

export default PlansConnected



// WEBPACK FOOTER //
// ./src/ui/screens/plans/Plans.js